export enum QuizMode {
  POPUP = "popup",
  FULL = "full",
  CUSTOM = "custom"
}